export default __webpack_public_path__ + "static/media/binary_code.fef7ad67.webp";